export default __webpack_public_path__ + "static/media/donut-tipping.04d79874.png";